module.exports = __webpack_public_path__ + "img/body-muscles-spasm.f073c4a.svg";